import React, { useContext, useState } from "react"

import CommonContext from "@src/context"
import classNames from "@utils/classnames"

import Clickable from "@components/clickable"
import Events from "@components/events"
import ClickOutside from "react-click-outsider"

import styles from "./nav.module.scss"
import logoImg from "@images/logo.png"
import zhiboImg from "@images/zhibo.png"

const Nav = () => {
  const { winWidth } = useContext(CommonContext)
  const [eventsDropDownVisible, setEventsDropDownVisible] = useState(false)
  const isMobileLayout = winWidth < 800
  return (
    <nav className={classNames(styles.nav)}>
      <div className={styles.logo}>
        <img src={logoImg} alt="logo" />
      </div>
      <div className={styles.menu}>
        <ClickOutside
          onClickOutside={() => {
            setEventsDropDownVisible(false)
          }}
        >
          <Clickable
            div
            className={styles.menuItem}
            onClick={() => {
              setEventsDropDownVisible(true)
            }}
          >
            热门赛事
            <small>Popular Race</small>
            {eventsDropDownVisible && (
              <div className={styles.dropdown}>
                <Events />
              </div>
            )}
          </Clickable>
        </ClickOutside>
      </div>
      <div className={styles.right}>
        {!isMobileLayout && (
          <a href="https://www.huya.com/spark2020">
            <img src={zhiboImg} />
          </a>
        )}
      </div>
    </nav>
  )
}

export default Nav
